import { Observable } from 'rxjs';
import { first, flatMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { authSelectors } from '../auth/auth.selectors';
import { AppState } from '../core.state';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.store.select(authSelectors.selectToken).pipe(
      first(),
      flatMap((token) => {
        if (token && request.url.includes(environment.backendApiUrl)) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })
        }

        return next.handle(request)
      })
    )
  }
}
